<template>
  <div class="form-wrapper">
    <div class="form-filter">
      <div class="group-title">
        <el-input v-model="queryForm.title" placeholder="请输入应用组名称"> </el-input>
      </div>
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <el-select
            placeholder="应用组筛选"
            :popper-append-to-body="false"
            v-model="queryForm.gameGroupId"
            @change="setPageQuery"
            clearable
            filterable
          >
            <el-option v-for="item in appGroupsData" :key="item.groupId" :label="item.groupName" :value="item.groupId"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select
            placeholder="中间件应用筛选"
            :popper-append-to-body="false"
            v-model="queryForm.mGameId"
            @change="setPageQuery"
            clearable
            filterable
          >
            <el-option v-for="item in middlewareGameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem style="margin-right: 0">
          <el-input v-model="queryForm.keyword" placeholder="请输入应用名称或ID" clearable @keyup.enter.native="setPageQuery">
            <i slot="append" @click="setPageQuery" class="el-icon-search"></i>
          </el-input>
        </ElFormItem>
      </ElForm>
    </div>

    <div class="transfer">
      <div class="left-list">
        <div class="list-header">
          <el-checkbox v-model="isCheckAll" @change="onCheckAllChange"></el-checkbox>
          <span>&ensp;应用名称</span>
        </div>

        <div class="list-items">
          <el-checkbox-group v-model="checkList">
            <div v-for="game in gameList" :key="game.gameId">
              <el-checkbox :label="game.gameId" @change="onCheckItemChange($event, game)">
                {{ game.gameName }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="right-results">
        <div class="list-header right-side">
          <span>已选（{{ resultsList.length }}）</span>
          <el-button class="remove-all" type="text" @click="onRemoveAll">清除全部</el-button>
        </div>

        <div class="list-items">
          <div class="itme result-item" v-for="game in resultsList" :key="game.gameId">
            <span class="game-name" :title="game.gameName">{{ game.gameName }}</span>
            <span class="close" @click="onResultItemRemove(game)"><Icon type="md-close-circle" /></span>
          </div>
        </div>
      </div>
    </div>

    <div class="transfer-footer">
      <el-pagination
        :current-page.sync="pager.pageIndex"
        :page-size.sync="pager.pageSize"
        :total="pager.total"
        :pager-count="5"
        @current-change="queryAction"
        @size-change="queryAction"
        layout="prev, pager, next, sizes"
        background
      >
      </el-pagination>

      <div class="btns">
        <el-button @click="onFormClose">取消</el-button>
        <el-button type="primary" @click="onFormConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils.js'
import { getPtomGroupGames } from '@/api/material.model'
import { getMiddleGameList } from '@/api/common.model'
import { appgroupQueryGame } from '@/api/report.model'
import { addUpdateAppGroup } from '@/api/sysmana.model.js'

const makeFormItem = () => {
  return {
    title: '',
    keyword: '',
    gameGroupId: '',
    mGameId: ''
  }
}
export default {
  data() {
    return {
      appGroupsData: [],
      middlewareGameData: [],
      gameList: [], // 本页数据
      resultsList: [], // 右侧已选游戏列表
      pager: {
        total: 0,
        pageIndex: 1,
        pageSize: 20
      },
      queryForm: makeFormItem()
    }
  },
  computed: {
    // 本页是否全选
    isCheckAll: {
      get() {
        const len = this.gameList.length
        if (!len) return false
        return this.gameList.every((g) => this.checkList.includes(g.gameId))
      },
      set(v) {}
    },
    // 全部勾选游戏的id
    checkList: {
      get() {
        return this.resultsList.map((g) => g.gameId)
      },
      set(list) {}
    }
  },
  created() {
    this.preloadData()
    this.queryAction()
  },
  methods: {
    /**
     * @description: 分页查询
     * @return {*}
     */
    queryAction() {
      const { title, ...params } = this.queryForm
      const { total, ...pager } = this.pager
      appgroupQueryGame({ ...pager, ...params }).then((data) => {
        const { list, page_info } = data
        this.gameList = list || []
        this.pager.total = page_info.total_number
      })
    },
    setPageQuery() {
      this.pager.pageIndex = 1
      this.queryAction()
    },
    /**
     * @description: 确认新建
     * @return {*}
     */
    onFormConfirm() {
      const { title, groupId } = this.queryForm
      const len = title.trim().length
      if (!len) return this.$Message.warning('应用组名称不能为空')
      if (len > 20) return this.$Message.warning('应用组名称不能超过20个字')
      if (!this.resultsList.length) return this.$Message.warning('请选择游戏')

      const params = {
        groupName: this.queryForm.title,
        gameIds: this.resultsList.map((g) => g.gameId).join(',')
      }

      if (groupId) {
        params.groupId = groupId
      }

      addUpdateAppGroup(params).then((data) => {
        if (data) {
          this.$Message.info('保存成功')
          this.onFormClose()
          this.$emit('query')
        }
      })
    },

    /**
     * @description: 关闭窗口，清空数据
     * @return {*}
     */
    onFormClose() {
      this.queryForm = makeFormItem()
      this.resultsList = []
      this.$emit('close')
    },

    /**
     * @description: 编辑时回显已选游戏、标题
     * @param {*} title
     * @param {*} res
     * @return {*}
     */
    setResults(row) {
      const gameIds = row.gameIds.split(',')
      const appNames = row.appNames.split(',')
      const apps = gameIds.map((i, index) => {
        return {
          gameId: Number(i),
          gameName: appNames[index]
        }
      })
      // 回显应用组名称
      this.queryForm.title = row.groupName
      // 保存groupId，编辑保存时要提交
      this.queryForm.groupId = row.groupId
      // 回显已选游戏
      this.resultsList = apps
      console.log('this.queryForm output: ', this.queryForm)
    },

    /**
     * @description: 删除已选结果
     * @return {*}
     */
    onResultItemRemove(game) {
      this.resultsList = this.resultsList.filter((g) => g.gameId !== game.gameId)
    },
    /**
     * @description: 左侧勾选单个游戏
     * @param {boolean} v
     * @param {object} game
     * @return {*}
     */
    onCheckItemChange(v, game) {
      if (v) {
        this.resultsList.push(game)
      } else {
        this.resultsList = this.resultsList.filter((g) => g.gameId !== game.gameId)
      }
    },
    /**
     * @description: 全选、取消全选
     * @param {boolean} v
     * @return {*}
     */
    onCheckAllChange(v) {
      this.gameList.forEach((g) => {
        if (v) {
          if (!this.checkList.includes(g.gameId)) {
            this.resultsList.push(g)
          }
        } else {
          if (this.checkList.includes(g.gameId)) {
            this.resultsList = this.resultsList.filter((r) => r.gameId !== g.gameId)
          }
        }
      })
    },
    /**
     * @description: 清除全部已选
     * @return {*}
     */
    onRemoveAll() {
      this.resultsList = []
    },
    preloadData() {
      Promise.all([getPtomGroupGames(), getMiddleGameList()]).then((data) => {
        const [appGroups, gameData] = data
        if (isArray(gameData)) {
          this.middlewareGameData = gameData
        }
        if (isArray(appGroups)) {
          this.appGroupsData = appGroups
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin border {
  border: 1px solid #eee;
  border-radius: 4px;
}

::v-deep .transfer {
  border-radius: 4px;
  display: flex;

  .left-list {
    flex: 1;
    overflow: hidden;
    @include border;
  }
  .right-results {
    margin-left: 10px;
    min-width: 180px;
    max-width: 180px;
    @include border;
  }

  .list-items {
    padding: 10px;
    max-height: 240px;
    min-height: 180px;
    overflow: auto;

    .el-checkbox .el-checkbox__label {
      font-size: 12px;
    }

    .result-item {
      display: flex;
      justify-content: space-between;

      &:hover {
        background: #eee;
      }
      span.game-name {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .close {
        cursor: pointer;
      }
    }
  }
  .list-header {
    line-height: 26px;
    background: #eee;
    padding: 0 10px;
    &.right-side {
      display: flex;
      justify-content: space-between;
    }
    .remove-all {
      padding: 0;
    }
  }
}

.group-title {
  margin-bottom: 10px;
}

.transfer-footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  ::v-deep.el-pagination__sizes {
    .el-input {
      input {
        height: 28px;
      }
    }
  }
}
</style>
